import React from "react";
import {
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  Box,
  useBreakpointValue,
} from "@chakra-ui/react";
import TradingViewWidget from "../traderView/TradingViewWidget";
import DataTradeEvents from "../../api/DataTradeEvents";
import { LuBarChart, LuListOrdered } from "react-icons/lu"; // Example icons


const TabSwitcher = () => {
  // Responsive tab width: full on mobile, 50% on medium and up
  const tabWidth = useBreakpointValue({ base: "100%", md: "50%" });

  return (
    <Box w="100%" h='100%' mt={9} p={0} bg='gray.200' border='0px solid gray'>
<Tabs
  isLazy
  variant="enclosed-colored"
  size="sm"
  w="100%"
  p={0}
  colorScheme="teal" // try "blue", "purple", "cyan", "orange", etc.
>
  <TabList>
    <Tab
      border="1px solid"
      borderColor="gray.300"
      w={tabWidth}
      //
      _selected={{ bg: "teal.100", fontWeight: "bold", color: "teal.700" }}
      _hover={{ bg: "gray.100" }}
    >
      <LuBarChart style={{ marginRight: 6 }} />
      Chart
    </Tab>
    <Tab
      border="1px solid"
      borderColor="gray.300"
      w={tabWidth}
      
      _selected={{ bg: "teal.100", fontWeight: "bold", color: "teal.700" }}
      _hover={{ bg: "gray.100" }}
    >
      <LuListOrdered style={{ marginRight: 6 }} />
      Orders
    </Tab>
  </TabList>

        <TabPanels w="100%">
          <TabPanel p={0}>
            <React.Suspense fallback={<div>Loading Chart...</div>}>
              <TradingViewWidget />
            </React.Suspense>
          </TabPanel>
          <TabPanel p={0}>
            <React.Suspense fallback={<div>Loading Orders...</div>}>
              <DataTradeEvents />
            </React.Suspense>
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Box>
  );
};

export default TabSwitcher;
